<template>
  <div class="d-flex flex-column innerpopup align-items-center f14-l19 " ref="popup" dir="rtl">
    <LikeComponent v-if="this.popup_data.likes" class="d-flex flex-row margin-bottom-10"  :likes="this.popup_data.likes" position="default" @click.stop="false" />
    <!-- <div class="bold d-flex flex-row f16-l19" v-html="this.popup_data.title" /> -->
    <div class="d-flex flex-column text-center f14-l19" v-for="(item,idx) in this.popup_data.texts" :key="idx" style="padding:5px 0;width: auto">
      <div class="d-flex flex-column " v-html="item" style="word-wrap: break-word;overflow-wrap: break-word;white-space: normal;"></div>
    </div>
    <div v-if="this.popup_data.personal_comment" class="d-flex flex-column text-center f14-l19" style="padding:5px 0;width: auto;max-width:250px;">
      <div class="d-flex flex-column " v-html="this.popup_data.personal_comment" style="word-wrap: break-word;overflow-wrap: break-word;white-space: normal;"></div>
    </div>
    <div class="d-flex flex-column text-center margin-top-5 f14-l19 red-link">
      <a :href="this.popup_data.link.href" @click="openLink" >{{ this.popup_data.link.text }}</a>
    </div>
  </div>
</template>
<script>
  import LikeComponent from "@/components/generic/LikeComponent.vue";

  export default {
    components: {
      LikeComponent,
    },
    props: {
      popup_data: Object
    },
    methods:{
      openLink(e){
        e.stopPropagation();
      }
  }
}
</script>
<style>
  .innerpopup {
    z-index: 4000;
    background: white;
    position: absolute;
    right: 0;
    top: 25px;
    border: 1px solid #ccc;
    padding: 20px 20px;
    min-width: max-content;
  }
</style>